module.exports = __webpack_public_path__ + "img/219-Veka Spectral 9011-Graphite.png";